import { render, staticRenderFns } from "./the-header.vue?vue&type=template&id=1496ea9a&"
import script from "./the-header.vue?vue&type=script&lang=js&"
export * from "./the-header.vue?vue&type=script&lang=js&"
import style0 from "./the-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
